<template>
    <div class="container singleIcon" style="margin: 0 auto">
        <!--        电脑-->
        <!--            <div class="row hidden-sm-and-down" style="height: 500px">-->
        <el-carousel
                style="position: relative;width: 100%;aspect-ratio: 15/7;"
                :interval="5000"
                class="hidden-sm-and-down"
                arrow="never"
                indicator-position="outside"
                :autoplay="false"

        >
            <!--                    height="400px"-->


            <el-carousel-item
                    style="width: 100%"
                    v-for="(item2, index2) in hxContentList"
                    :key="index2">
                <!--                        <el-image-->
                <!--                                class="image"-->
                <!--                                :src="item2.url"-->
                <!--                        ></el-image>-->
                <div class="bigDiv" style="">
                    <img :src="item2.url">
                </div>
                <div class="content">
                    <div
                            v-if="item2.title"
                            style="color: #333; margin-left: 20px;padding: 10px 0;font-weight: bold"
                    >
                        {{ item2.title }}
                    </div>
                    <div
                            class="ql-editor content-p"
                            v-if="item2.content"
                            v-html="item2.content"
                    />
                </div>
            </el-carousel-item>
        </el-carousel>
        <!--            </div>-->
        <!--         平板 手机-->
        <div class="hidden-sm-and-up">
            <el-row class="row">
                <el-carousel
                        height="490px"
                        :interval="5000"
                        arrow="never"
                >
                    <el-carousel-item
                            v-for="(item2, index2) in hxContentList"
                            :key="index2">
                        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="240"
                                style="display: flex;justify-content: center">
                            <!--                            <el-image-->
                            <!--                                    style="width: 100%;height: 200px;"-->
                            <!--                                    :src="item2.url"-->
                            <!--                            ></el-image>-->
                            <div class="bigDiv" style="width: 100%">
                                <img :src="item2.url">
                            </div>
                        </el-col>
                        <el-col
                                :xs="24"
                                :sm="24"
                                :md="24"
                                :lg="24"
                                :xl="24"
                        >
                            <div class="phone-content">
                                <div
                                        v-if="item2.title"
                                        style="color: #333; margin-left: 20px;padding: 10px 0;font-weight: bold"
                                >
                                    {{ item2.title }}
                                </div>
                                <div
                                        class="ql-editor content-p"
                                        v-if="item2.content"
                                        v-html="item2.content"
                                />
                            </div>
                        </el-col>
                    </el-carousel-item>
                </el-carousel>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "single-rotation-index",
        props: {
            hxContentList: Array
        }
    }
</script>
<style lang="scss">
    .singleIcon {
        .el-carousel__container {
            width: 100%;
            height: 90%;
        }
        .el-carousel__button {
            background-color: #C0C4CC;

        }
    }
</style>
<style lang="scss" scoped>
    .container {
        width: 70%;
        aspect-ratio: 15/8;
    }

    .bigDiv {
        width: 75%;
        /*width: 100%;*/
        /*width: 75%;*/
        aspect-ratio: 15/8;
        /*height: 350px;*/
    }

    .bigDiv img {
        transform: translateX(1px); //解决element ui轮播位移失真
        width: 100%;
    }

    .image {
        width: 75%;
        z-index: -9;
        height: 400px;
    }

    .content {
        /*box-shadow: rgba(0, 0, 0, 0.5) 0px 10px 30px;*/
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
        position: absolute;
        right: 1%;
        width: 30%;
        top: 20px;
        background: white;
        border-radius: 4px;
        padding: 10px 15px 15px 15px;
    }

    .phone-content {
        width: 100%;
    }

    .content-p {
        text-indent: 24px;
        font-size: 14px;

        color: #333;
        height: 250px;
        line-height: 32px;
        /*margin: 0 15px;*/

        padding: 0;
    }

    @media screen and (max-width: 1400px) {
        /*.type-area {*/
        /*    width: 55%;*/
        /*    margin: 0 auto;*/
        /*}*/

        .content-p {
            height: 220px;
        }
    }

    @media screen and (min-width: 1200px) {
        .container {
            width: 70%;
        }

        /*.row {*/
        /*    margin: 0 20px !important;*/
        /*}*/


    }

    @media screen and (max-width: 1200px) {
        .content-p {
            height: 180px;
        }
    }

    @media screen and (max-width: 1100px) {
        .content-p {
            height: 150px;
        }
    }

    @media screen and (max-width: 870px) {
        .container {
            width: 90%;
        }
        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        /*.row {*/
        /*    margin: 0 20px !important;*/
        /*}*/
    }

    @media screen and (max-width: 570px) {
        .container {
            width: 90%;
        }
        /*.type-area {*/
        /*    width: 100%;*/
        /*    margin: 0 auto;*/
        /*}*/

        /*.row {*/
        /*    margin: 0 20px !important;*/
        /*}*/
    }
</style>
